import { AppContext } from '../../../helpers'
import { TestExecution, Test } from '../../models'

export class TestExecutionFactory {
  public constructor(
    private _appContext: AppContext
  ) {}

  public create(testId: string) {
    return this._createTestExecution(testId, this._appContext.currentUser.id)
  }

  private _createTestExecution(testId: string, userId: string) {
    const execution = new TestExecution()
    execution.userId = userId
    execution.test = this._createTest(testId)
    return execution
  }

  private _createTest(testId: string) {
    const test = new Test()
    test.name = ''
    test.id = testId
    return test
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/factories/test-execution/test-execution.factory.ts